/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListCommentContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "ReplyListCommentContainer_viewer";
};
export type ReplyListCommentContainer_viewer$data = ReplyListCommentContainer_viewer;
export type ReplyListCommentContainer_viewer$key = {
    readonly " $data"?: ReplyListCommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '38a388ea35b80ca074143c70510a2b74';
export default node;
